import { render, staticRenderFns } from "./FriendsSite.vue?vue&type=template&id=1cd0b01b&scoped=true&"
import script from "./FriendsSite.vue?vue&type=script&lang=js&"
export * from "./FriendsSite.vue?vue&type=script&lang=js&"
import style0 from "./FriendsSite.vue?vue&type=style&index=0&id=1cd0b01b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd0b01b",
  null
  
)

export default component.exports